// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3OLRl","containerItemsCenter":"Skeleton_containerItemsCenter__2ShPX"};